import AjouterProjetFormV2 from "../components/AjouterProjetForm/AjouterProjetFormV2";

function AjouterProjetPage() {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <AjouterProjetFormV2 />
    </div>
  );
}

export default AjouterProjetPage;
